<template>
    <div class="pt-8 pb-16 relative">
        <LayoutsSectionRowTemplate>
            <template #title>
                <h2 class="text-2xl sm:text-3xl md:text-4xl font-semibold mb-8" v-html="customize.title"></h2>
            </template>
            <template #description>
                <div class="text-base xs:text-lg wrap-content" v-html="customize.content">

                </div>
                <div class="mt-12">
                    <a :href="useRuntimeConfig().public.app_user_url" target="_blank"
                        class="flex items-center justify-center gap-2 h-12 px-8 bg-success font-esbuild hover:bg-success-tier text-white w-fit focus-visible:shadow-button-focus-success whitespace-nowrap rounded-full">
                        <span>{{ customize.button }}</span>
                        <ArrowRightIcon />
                    </a>
                </div>
            </template>
            <template #image>
                <nuxt-img loading="lazy" src="home/fuel-agency-growth.png" alt="analytic-qr-code" format="webp" />
            </template>
        </LayoutsSectionRowTemplate>
    </div>
</template>
<script lang="ts" setup>
import { ArrowRightIcon } from "vue-tabler-icons";
import AnalyticLocale from "~~/config/widgets/analytic-widget";

const localePath = useLocalePath()
const customize = (new AnalyticLocale()).data
</script>